import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /Users/ijaemun/Documents/Codex/2026-09-30/task/migration-prep/mac-candidate-build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
}

.layout-header-organization {
  position: relative;
  top: 2px;
}

.layout-footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 44px;
  padding: 6px 20px;
  box-sizing: border-box;
}

.layout-footer-modern {
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
}

.layout-footer-retro {
  min-height: 40px;
  padding: 5px 16px;
  background: #f5f5f5;
  border-top: 1px solid #cccccc;
}

.layout-footer-left {
  display: flex;
  align-items: center;
  min-width: 44px;
}

.layout-footer-brand {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 0;
}

.layout-footer-brand-text {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  line-height: 1;
  white-space: nowrap;
}

.layout-footer-logo {
  display: block;
  height: 30px;
  max-width: min(180px, 28vw);
  object-fit: contain;
}

.layout-footer-logo-modern {
  opacity: 0.9;
}

.layout-footer-logo-retro {
  height: 28px;
  opacity: 0.92;
}

.theme-mode-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  padding: 0;
  border: 0;
  border-radius: 0;
  color: #64748b;
  background: transparent;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: color 140ms ease;
}

.theme-mode-toggle:hover {
  color: #1e293b;
  background: transparent;
}

.theme-mode-toggle.is-dark {
  color: #cbd5e1;
  background: transparent;
}

.theme-mode-toggle.is-dark:hover {
  color: #ffffff;
  background: transparent;
}

.theme-mode-toggle-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 13px;
}

:host-context(.ui-dark) .layout-footer-modern {
  background: #0f172a;
  border-top-color: #1e293b;
}
:host-context(.ui-dark) .layout-footer-brand-text {
  color: #cbd5e1;
}

@media (max-width: 767px) {
  .layout-modern-header {
    height: 52px !important;
    padding-left: 12px !important;
    padding-right: 8px !important;
    gap: 8px;
    overflow: hidden;
  }
  .layout-modern-brand {
    flex: 0 0 auto;
    max-width: 124px;
    min-width: 0;
    padding-right: 4px !important;
  }
  .layout-modern-brand .layout-header-logo,
  .layout-retro-brand .layout-header-logo {
    width: 38px !important;
    height: 28px !important;
  }
  .layout-modern-brand .layout-header-copy,
  .layout-retro-brand .layout-header-copy {
    gap: 1px !important;
  }
  .layout-modern-brand .layout-header-product,
  .layout-retro-brand .layout-header-product {
    display: block;
    font-size: 12px !important;
    line-height: 1 !important;
    letter-spacing: 0 !important;
    white-space: nowrap;
  }
  .layout-modern-brand .layout-header-organization,
  .layout-retro-brand .layout-header-organization {
    display: block;
    font-size: 9px !important;
    line-height: 1 !important;
    white-space: nowrap;
  }
  .layout-modern-actions {
    flex: 1 1 auto;
    min-width: 0;
    gap: 8px !important;
    justify-content: flex-end;
  }
  .layout-modern-nav {
    flex: 1 1 auto;
    min-width: 0;
    gap: 4px !important;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .layout-modern-nav::-webkit-scrollbar {
    display: none;
  }
  .layout-modern-nav a {
    flex: 0 0 auto;
    white-space: nowrap;
    padding: 6px 8px !important;
    font-size: 12px !important;
    line-height: 1.2;
  }
  .layout-modern-divider,
  .layout-user-name,
  .layout-modern-user a {
    display: none !important;
  }
  .layout-modern-user {
    flex: 0 0 auto;
    gap: 0 !important;
  }
  .layout-modern-user > div {
    width: 28px !important;
    height: 28px !important;
  }
  .layout-retro-shell {
    min-width: 0;
  }
  .layout-retro-header {
    height: 44px !important;
    gap: 8px;
    overflow: hidden;
    padding-left: 12px !important;
    padding-right: 8px !important;
  }
  .layout-retro-brand {
    flex: 0 0 auto;
    max-width: 126px;
    min-width: 0;
    padding-right: 6px !important;
  }
  .layout-retro-user {
    flex: 0 0 auto;
    gap: 0 !important;
  }
  .layout-retro-user span {
    display: none !important;
  }
  .layout-retro-user a {
    display: inline-block !important;
    max-width: 54px;
    overflow: hidden;
    font-size: 11px !important;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .layout-retro-nav-bar {
    overflow: hidden;
  }
  .layout-retro-nav {
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .layout-retro-nav::-webkit-scrollbar {
    display: none;
  }
  .layout-retro-nav a {
    flex: 0 0 auto;
    padding: 8px 10px !important;
    font-size: 12px !important;
    line-height: 1.2;
    white-space: nowrap;
  }
  .layout-retro-body {
    overflow: hidden !important;
  }
  .layout-footer {
    display: none;
  }
}
@media (max-width: 640px) {
  .layout-footer {
    min-height: 40px;
    padding: 5px 12px;
  }
  .layout-footer-logo {
    height: 24px;
    max-width: 34vw;
  }
  .layout-footer-brand-text {
    display: none;
  }
  .theme-mode-toggle {
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit {
    public theme: string = 'modern';
    public colorMode: string = 'light';
    private readonly settingsReturnKey: string = 'inspection.settings.returnUrl';
    private readonly colorModeStorageKey: string = 'ui-color-mode';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.theme = localStorage.getItem('ui-theme') || 'modern';
        this.applyColorMode(this.storedColorMode(), false);
        await this.service.render();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', false);
    }

    @HostListener('window:storage', ['$event'])
    public onStorageChange(event: StorageEvent) {
        if (event.key === 'ui-theme') {
            this.theme = event.newValue || 'modern';
            this.service.render();
        }
        if (event.key === this.colorModeStorageKey) {
            this.applyColorMode(event.newValue || 'light', false);
            this.service.render();
        }
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    private normalizeColorMode(value: any): string {
        return String(value || '').trim().toLowerCase() === 'dark' ? 'dark' : 'light';
    }

    private storedColorMode(): string {
        try {
            return this.normalizeColorMode(localStorage.getItem(this.colorModeStorageKey));
        } catch (e) {
            return 'light';
        }
    }

    private applyColorMode(value: any, persist: boolean = true) {
        const mode = this.normalizeColorMode(value);
        const isDark = mode === 'dark';
        this.colorMode = mode;
        try {
            if (persist) localStorage.setItem(this.colorModeStorageKey, mode);
        } catch (e) { }
        try {
            document.documentElement.classList.toggle('ui-dark', isDark);
            document.documentElement.classList.toggle('ui-light', !isDark);
            document.documentElement.style.colorScheme = mode;
            if (document.body) {
                document.body.classList.toggle('ui-dark', isDark);
                document.body.classList.toggle('ui-light', !isDark);
                document.body.style.colorScheme = mode;
            }
        } catch (e) { }
    }

    public async toggleColorMode(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const nextMode = this.colorMode === 'dark' ? 'light' : 'dark';
        this.applyColorMode(nextMode);
        await this.service.render();
    }

    private getCurrentUrl(): string {
        return `${location.pathname}${location.search || ''}${location.hash || ''}`;
    }

    private safeInspectionUrl(url: any): string {
        const value = String(url || '').trim();
        if (!value || value.startsWith('//')) return '';
        if (value === '/chatbot' || value.startsWith('/chatbot/') || value.startsWith('/chatbot?') || value.startsWith('/chatbot#')) return value;
        return '';
    }

    public openSettings(event?: Event) {
        if (event) event.preventDefault();
        const returnUrl = this.safeInspectionUrl(this.getCurrentUrl());
        try {
            if (returnUrl) {
                sessionStorage.setItem(this.settingsReturnKey, returnUrl);
            }
        } catch (e) { }
        const target = returnUrl
            ? `/admin/settings?return=${encodeURIComponent(returnUrl)}`
            : '/admin/settings';
        this.service.href(target);
    }

    public logout(event?: Event) {
        this.service.auth.logout('/access', event);
    }
}

export default LayoutSidebarComponent;